// src/features/dashboard/components/WelcomeHeader.tsx

import React from 'react';
import { motion } from 'framer-motion';
import Skeleton from '../../../components/Skeleton';

interface WelcomeHeaderProps {
  userName?: string;
  loading?: boolean;
}

// Welcome header with user greeting
export const WelcomeHeader = React.memo<WelcomeHeaderProps>(({ userName, loading = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="mb-4"
    >
      {loading ? (
        <div className="space-y-2">
          <Skeleton variant="text" width="40%" height={32} />
          <Skeleton variant="text" width="60%" height={16} />
        </div>
      ) : (
        <>
          <h1 className="text-2xl font-bold theme-text-primary mb-1">
            Welcome back, {userName || 'User'}
          </h1>
          <p className="text-sm theme-text-secondary">
            Here's an overview of your SelectRow project management system.
          </p>
        </>
      )}
    </motion.div>
  );
});

WelcomeHeader.displayName = 'WelcomeHeader';
